const ApiLoadingStatus = Object.freeze({
  STATUS_LOADING: 'Loading',
  STATUS_ERROR_LOADING: 'Failed',
  STATUS_SUCCESSFUL: 'Successful',
  STATUS_NOT_INITIALIZED: 'NotInitialized',
});

export default ApiLoadingStatus;
